<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-4"><a id="_idTextAnchor005"></a>Look Up</h1>
<p class="Verse-first">We were friends </p>
<p class="Verse-main">We were colleagues</p>
<p class="Verse-main">We shared summers and winters</p>
<p class="Verse-main">We protected each other’s backs</p>
<p class="Verse-main">Took care of all our needs</p>
<p class="Verse-new">I then made a sacrifice you did not</p>
<p class="Verse-main">Not through choice</p>
<p class="Verse-main">Just good or bad luck</p>
<p class="Verse-new">So tell me my old friend</p>
<p class="Verse-main">Why do you look to the floor?</p>
<p class="Verse-main">When we pass each other</p>
<p class="Verse-main">Your eyes touch the floor</p>
<p class="Verse-new">You tell me not to come around</p>
<p class="Verse-main">Am I dirty or unclean now?</p>
<p class="Verse-main">Why do you frown?</p>
<p class="Verse-main">Is it guilt or fear or both?</p>
<p class="Verse-new">And when I came back</p>
<p class="Verse-main">You still looked to my feet</p>
<p class="Verse-main">Friends no more?</p>
<p class="Verse-main">It’s not my face you can’t stand</p>
<p class="Verse-main">I suspect it’s yours you no longer adore</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398433502_EPUB8.vue?0fcafb9e